import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

import { userstate, createNlsMiddleware } from 'lcc-state';

import { css } from '../css/roster.m.css';
import { svc, RosterMember } from '../support/svc';
import { Instructor } from './instructor';
import { Member } from './member';

interface ClassRosterICache {
	roster: RosterMember[];
}

const factory = create({
	icache: createICacheMiddleware<ClassRosterICache>(),
	nls: createNlsMiddleware('roster'),
	userstate,
	theme
});

export const ClassRoster = factory(({ middleware: { icache, nls, userstate, theme } }) => {
	const { get, path } = userstate;
	const user_id = get(path('user_id'));

	const {
		isPlaceholder,
		messages: { your_instructor = '', your_instructors = '', you = '', others_in_session = '' }
	} = nls();
	if (isPlaceholder) {
		return null;
	}

	const themedCss = theme.classes(css);

	icache.getOrSet('roster', async () => {
		return await svc.roster_members({
			session_id: window.hcstatic.course_session?.pk
		});
	});

	const instructors = icache.get('roster')?.filter((member: RosterMember) => {
		return member.is_instructor;
	});

	const instructorHeader = instructors && instructors.length > 1 ? your_instructors : your_instructor;

	const currentMember = icache.get('roster')?.filter((member: RosterMember) => {
		return member.member_id === user_id;
	});

	const classmates = icache.get('roster')?.filter((member: RosterMember) => {
		return !member.is_instructor && member.member_id !== user_id;
	});

	return v('div', { classes: [themedCss.atiContainer] }, [
		v('div', { classes: 'row' }, [
			v('div', { classes: [themedCss.leftPanel, 'col-xs-12', 'col-sm-6'], xqa: 'current-member-panel' }, [
				v('div', { classes: 'row' }, [v('div', { classes: 'col-xs-12' }, [v('h2', { innerHTML: you })])]),
				currentMember ? w(Member, { members: currentMember, size: 'medium', showProfileLink: true }) : null
			]),
			v('div', { classes: [themedCss.rightPanel, 'col-xs-12', 'col-sm-6'], xqa: 'instructors-panel' }, [
				v('div', { classes: 'row' }, [
					v('div', { classes: 'col-xs-12' }, [v('h2', { innerHTML: instructorHeader })])
				]),
				instructors ? w(Instructor, { instructors: instructors, size: 'medium', showAskLink: true }) : null
			])
		]),
		classmates && classmates.length > 0
			? v('div', { classes: [themedCss.classmates, 'row'], xqa: 'full-roster-panel' }, [
					v('div', { classes: [themedCss.classmatesTitle, 'col-xs-12'] }, [
						v('h2', { innerHTML: others_in_session })
					]),
					w(Member, { members: classmates, size: 'small', showProfileLink: false })
			  ])
			: null
	]);
});
